module.exports = __webpack_public_path__ + "static/media/Model 2_page-0001.5916c29c.jpg";